// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-list-container,
.customer-form-container,
.customer-schedule-container,
.customer-relations-container {
  padding-top: 20px;
  padding-bottom: 40px;
}

.customer-table th,
.customer-table td {
  vertical-align: middle;
}

.card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.card-header {
  background-color: #f8f9fa;
  font-weight: 500;
}

@media (max-width: 768px) {
  .customer-list-container,
  .customer-form-container,
  .customer-schedule-container,
  .customer-relations-container {
    padding-top: 10px;
  }
  
  .customer-table {
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Customer/Customer.css"],"names":[],"mappings":"AAAA;;;;EAIE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;;;;IAIE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".customer-list-container,\n.customer-form-container,\n.customer-schedule-container,\n.customer-relations-container {\n  padding-top: 20px;\n  padding-bottom: 40px;\n}\n\n.customer-table th,\n.customer-table td {\n  vertical-align: middle;\n}\n\n.card {\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-bottom: 20px;\n}\n\n.card-header {\n  background-color: #f8f9fa;\n  font-weight: 500;\n}\n\n@media (max-width: 768px) {\n  .customer-list-container,\n  .customer-form-container,\n  .customer-schedule-container,\n  .customer-relations-container {\n    padding-top: 10px;\n  }\n  \n  .customer-table {\n    font-size: 0.9rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
